import { render, staticRenderFns } from "./SbsHome.vue?vue&type=template&id=a1370612&scoped=true"
import script from "./SbsHome.vue?vue&type=script&lang=js"
export * from "./SbsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1370612",
  null
  
)

export default component.exports